export type WorkflowPermissions = Record<string, string[]> | null
export interface WorkflowOptions {
  organization_id: string
  organization_name: string
  workflows: Array<{ name: string; title: string }>
  available: boolean
  environment?: string | null
}
export type WorkflowCopy = Record<string, string>

type Props = { options: WorkflowOptions | null; selected: string[]; copy: WorkflowCopy; disabled?: boolean; onChange: (names: string[]) => void }
export default function WorkflowChecklist({ options, selected, copy, disabled = false, onChange }: Props) {
  const names = new Set(options?.workflows.map((item) => item.name) || [])
  const workflows = [...(options?.workflows || []), ...selected.filter((name) => !names.has(name)).map((name) => ({ name, title: name }))]
  return <div className="space-y-3">
    {!options?.available && <p className="text-xs text-muted-foreground" role="status">{options ? copy.unavailable : copy.load_hint}</p>}
    <div className="grid max-h-56 gap-2 overflow-y-auto rounded-md border border-border p-3">
      {workflows.map((workflow) => {
        const checked = selected.includes(workflow.name)
        return <label key={workflow.name} className="flex items-start gap-2 text-sm">
          <input type="checkbox" className="mt-1" checked={checked} disabled={disabled || (!options?.available && !checked)}
            onChange={() => onChange(checked ? selected.filter((name) => name !== workflow.name) : [...selected, workflow.name])} />
          <span>{workflow.title}{workflow.title !== workflow.name && <span className="ml-1 text-xs text-muted-foreground">{workflow.name}</span>}
            {!names.has(workflow.name) && <span className="ml-1 text-xs text-muted-foreground">· {copy.unavailable_selection}</span>}</span>
        </label>
      })}
      {!workflows.length && <p className="text-sm text-muted-foreground">{options?.available ? copy.empty : copy.none}</p>}
    </div>
    <p className="text-xs text-muted-foreground">{copy.selected}: {selected.length} · {copy.published_only}</p>
  </div>
}
